import theme from '@adsk/alloy-react-theme';

export const avatarContainer = {
  paddingRight: '10px',
  alignSelf: 'center',
  flex: '0 0 50px',
};

export const menuStyle = {
  width: '190px',
};

export const descriptionStyle = {
  paddingBottom: '20px',
};

export const nameStyle = {
  fontWeight: 'bold',
  paddingBottom: '5px',
};

export const emailStyle = {
  color: theme.colors.adskBlue700,
  textDecoration: 'none',
};

export const confirmationModalStyle = {
  maxWidth: '600px',
  width: '100%',
};

export const flexContainer = { display: 'flex' };
